<script>
    export let subscriptionName = '';
    export let onClose;
    export let propsForForm;

    const addNewSubscription = propsForForm && propsForForm[0]

    const createSubscription = () => {
        fetch(`/api/v1/create-subscription`, {
            body: JSON.stringify({
                subscriptionName,
            }),
            method: 'POST',
        })
        .then(data => data.json())
        .then(response => {
            addNewSubscription(response.subscription);
            onClose();
        });
    }
</script>

<form id="new-subscription-form">
    <input bind:value={subscriptionName} class="input" type="text" name="subscription-name" autocomplete="off" placeholder="Name" data-required="true" required />
    <button on:click|preventDefault={() => createSubscription()} type="submit" form="new-subscription-form" class="primary-red">
        Create Group
    </button>
</form>

<style>
    #new-subscription-form {
        display: flex;
        flex-direction: column;
    }
</style>